<template>
    <div style="background:#eee;padding: 20px;width:90%;margin:0 auto;">
        <Card :bordered="false" dis-hover style="min-height: 300px;">
            <p slot="title" style="font-size: 14px;">发票信息</p>
            <div style="height: 500px;overflow-y: auto;">
                <Button :type="this.invoicetype === '1'? 'info' : 'default'" shape="circle" style="margin-left:110px;margin-bottom:20px;width:100px" @click="switchTitle('1')">普通发票</Button>
                <Button :disabled="this.isReissue" :type="this.invoicetype === '2'? 'info' : 'default'" shape="circle" style="margin-left:20px;margin-bottom:20px;width:150px" @click="switchTitle('2')">增值税专用发票</Button>
                <Form :model="formData" ref="formData" :label-width="110" :rules="ruleValidate">
                    <FormItem label="发票抬头">
                        <RadioGroup v-model="formData.headertype" @on-change="headertypeChange">
                            <Radio label="2">单位</Radio>
                            <Radio label="1" :disabled="invoicetype==='2'">个人</Radio>
                        </RadioGroup>
                    </FormItem>
                    <div :style="{display:formData.headertype==='1'?'block':'none'}">
                        <FormItem label="发票抬头" prop="headername" v-if="formData.headertype==='1'">
                            <Input v-model="formData.headername" maxlength="128" clearable style="width: 300px" />
                        </FormItem>
                        <Divider>收票人信息</Divider>
                        <FormItem label="电子邮件" prop v-if="formData.headertype==='1'">
                            <Input v-model="formData.postemail" maxlength="32" clearable style="width: 300px" />
                            <!-- <span v-if="mail_warning.isshow" style="display: block;line-height: 12px;height: 12px;margin-top: 10px;color:#ed4014;">{{mail_warning.desc}}</span> -->
                        </FormItem>
                        <FormItem label="手机号码" prop v-if="formData.headertype==='1'">
                            <Input v-model="formData.postmobile" maxlength="16" clearable style="width: 300px" />
                        </FormItem>
                    </div>
                    <div :style="{display:formData.headertype==='2'?'block':'none'}">
                        <FormItem label="单位名称" prop="headername" v-if="formData.headertype==='2'">
                            <Input v-model="formData.headername" maxlength="128" clearable style="width: 300px" />
                        </FormItem>
                    </div>
                    <FormItem label="纳税人识别号" prop="headercode" v-if="formData.headertype==='2'">
                        <Input v-model="formData.headercode" maxlength="32" clearable style="width: 300px" />
                    </FormItem>
                    <div :style="{display:invoicetype==='1'&&formData.headertype==='2'?'block':'none'}">
                        <FormItem label="注册地址"  prop v-if="invoicetype==='1'&&formData.headertype==='2'">
                            <Input v-model="formData.officeaddress" maxlength="128" clearable style="width: 300px" />
                        </FormItem>
                        <FormItem label="注册电话" prop v-if="invoicetype==='1'&&formData.headertype==='2'">
                            <Input v-model="formData.mobilenumber" maxlength="32" clearable style="width: 300px" />
                        </FormItem>
                        <FormItem label="开户银行" prop v-if="invoicetype==='1'&&formData.headertype==='2'">
                            <Input v-model="formData.bankname" maxlength="128" clearable style="width: 300px" />
                        </FormItem>
                        <FormItem label="银行账号" prop v-if="invoicetype==='1'&&formData.headertype==='2'">
                            <Input v-model="formData.bankaccount" maxlength="32" clearable style="width: 300px" />
                        </FormItem>
                        <Divider>收票人信息</Divider>
                        <FormItem label="电子邮件" prop v-if="invoicetype==='1'&&formData.headertype==='2'">
                            <Input v-model="formData.postemail" maxlength="32" clearable style="width: 300px" />
                        </FormItem>
                        <FormItem label="手机号码" prop v-if="invoicetype==='1'&&formData.headertype==='2'">
                            <Input v-model="formData.postmobile" maxlength="16" clearable style="width: 300px" />
                        </FormItem>
                    </div>
                    <div :style="{display:invoicetype==='2'&&formData.headertype==='2'?'block':'none'}">
                        <FormItem label="注册地址" prop="officeaddress" v-if="invoicetype==='2'&&formData.headertype==='2'">
                            <Input v-model="formData.officeaddress" maxlength="128" clearable style="width: 300px" />
                        </FormItem>
                        <FormItem label="注册电话" prop="mobilenumber" v-if="invoicetype==='2'&&formData.headertype==='2'">
                            <Input v-model="formData.mobilenumber"  maxlength="32" clearable style="width: 300px" />
                        </FormItem>
                        <FormItem label="开户银行" prop="bankname" v-if="invoicetype==='2'&&formData.headertype==='2'">
                            <Input v-model="formData.bankname"  maxlength="128" clearable style="width: 300px" />
                        </FormItem>
                        <FormItem label="银行账号" prop="bankaccount" v-if="invoicetype==='2'&&formData.headertype==='2'">
                            <Input v-model="formData.bankaccount" maxlength="32" clearable style="width: 300px" />
                        </FormItem>
                        <Divider>收票人信息</Divider>
                        <FormItem label="邮寄地址" prop="postaddress" v-if="invoicetype==='2'&&formData.headertype==='2'">
                            <Input v-model="formData.postaddress" maxlength="128" clearable style="width: 300px" />
                        </FormItem>
                        <FormItem label="手机号码" prop="postmobile" v-if="invoicetype==='2'&&formData.headertype==='2'">
                            <Input v-model="formData.postmobile" maxlength="32" clearable style="width: 300px" />
                        </FormItem>
                    </div>
                    <!-- <FormItem label="总金额" prop="total" v-if="isModal">
            <span>{{invoiceTotal}} 元</span>
          </FormItem> -->
                    <!-- <FormItem v-if="!isModal">
            <Button type="dashed" @click="Cancel" style="margin-right: 20px">取消</Button>
            <Button type="primary" @click="Ok">确定</Button>
          </FormItem>-->
                </Form>
            </div>
        </Card>
    </div>
</template>
<script>
import ConstJson from '../../api/common/constjson'
import store from "../../store/"
let constJ = new ConstJson()
export default {
    props: {
        isModal: {
            type: Boolean,
            default: false,
        },
        //是否可开增票
        isReissue: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            mail_warning: {
                isshow: false,
                desc: ''
            },
            remData: {},
            orderid: '',
            invoicetype: '1', //1=普通发票  2=增值税发票
            currentgetheadername: '',
            remheadertype: 1,
            formData: {
                headertype: '1', //"1"=个人   "2"=单位
                headername: '',
                headercode: '',
                officeaddress: '',
                mobilenumber: '',
                bankname: '',
                bankaccount: '',
                postaddress: '',
                postemail: '',
                postmobile: '',
            },
            invoiceTotal: 0, //发票实际支付金额
            isshow: true,
            // input 验证
            ruleValidate: {

                headername: [{
                    required: true,
                    message: '请填写名称',
                    trigger: 'blur'
                }, ],
                headercode: [{
                    required: true,
                    message: '请填写纳税人识别号',
                    trigger: 'blur'
                }, ],
                officeaddress: [{
                    required: true,
                    message: '请填写注册地址',
                    trigger: 'blur'
                }, ],
                mobilenumber: [{
                    required: true,
                    message: '请填写注册电话',
                    trigger: 'blur'
                }, ],
                bankname: [{
                    required: true,
                    message: '请填写开户银行',
                    trigger: 'blur'
                }, ],
                bankaccount: [{
                    required: true,
                    message: '请填写银行账号',
                    trigger: 'blur'
                }, ],
                postaddress: [{
                    required: true,
                    message: '请填写邮寄地址',
                    trigger: 'blur'
                }, ],
                postemail: [{
                    required: true,
                    message: '请填电子邮箱',
                    trigger: 'blur'
                }, ],
                postmobile: [{
                    required: true,
                    message: '请填写手机号码',
                    trigger: 'blur'
                }, ],
            }
        }
    },
    computed: {

    },
    created() {},
    methods: {
        checkmail() {
            console.log('checkmail=====>')
            if (!this.$Tools.isEmptyOrEmail(this.formData.postemail)) {
                this.mail_warning.isshow = true
                this.mail_warning.desc = "邮箱格式错误"
            } else {
                this.mail_warning.isshow = false
                this.mail_warning.desc = ""
            }
        },
        headertypeChange(value) {
            console.log(value);
            this.$refs.formData.resetFields()
            if (value == 1) {
                if (this.remheadertype == 1) {
                    //init
                    this.getInvoice()
                } else {
                    this.formData.headername = '个人'

                }
            } else {
                if (this.remheadertype == 1) {
                    this.$refs.formData.resetFields()
                    this.formData.headername = ''

                } else {
                    this.$refs.formData.resetFields()
                    this.formData.headername = ''
                    //init
                    this.getInvoice()
                }
            }


        },
        switchTitle(value) {
            if (this.invoicetype == value) {
                return
            } else {
                this.invoicetype = value
                if (value == '2') {
                    if (this.formData.headertype == 1) {
                        this.formData.headername = ''

                    }
                    this.formData.headertype = '2'
                    console.log(this.formData.headertype);
                    console.log(this.remheadertype);
                    if (this.remheadertype == 2) {
                        // init
                        this.getInvoice()
                    }
                } else {
                    // init
                    this.getInvoice()

                }

            }

        },
        Cancel() {

        },
        getInvoice() {
            //读取发票抬头信息
            console.log('读取发票抬头信息');
            if (JSON.stringify(this.remData) == '{}') {
                constJ.reqGetInvoiceTitle().then(res => {
                    console.log(res)
                    if (res.rltcode === 1 && res.rtncode === 1) {
                        console.log('接口值');
                        this.formData = { ...this.formData, ...res.item, headertype: res.item.headertype.toString() }
                        this.currentgetheadername = this.formData.headername
                        this.remheadertype = res.item.headertype
                        console.log(this.invoicetype);
                        //修改父组件属性值
                        this.$parent.$parent.sonheadertype = Number(this.formData.headertype)
                        this.$parent.$parent.invoiceHeaderName = this.formData.headertype == 1 ? '个人' : '单位'

                    } else {
                        console.log('初始值');
                        this.formData.headertype = "1"
                        this.formData.headername = '个人'
                    }
                }).catch(function(err) {
                    console.log(err)
                })
            } else {
                console.log('赋值');
                this.formData = JSON.parse(JSON.stringify(this.remData))
                console.log(this.formData);
            }

        },
        saveInvoice() {
            //保存发票抬头信息
            constJ.reqSaveInvoiceTitle(this.formData).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {

                }
            })
        },
        takeInvoice() {
            console.log('take a invoice====>')
            //开票
            this.$refs.formData.validate((valid) => {
                if (valid) {
                    let a = {
                        orderid: this.orderid,
                        invoicetype: Number(this.invoicetype),
                        invoiceheader: {
                            ...this.formData,
                            headertype: Number(this.formData.headertype)
                        }
                    }
                    constJ.reqTakeInvoice(a).then(res => {
                        console.log(res)
                        if (res.rltcode === 1 && res.rtncode === 1) {

                        }
                    })
                } else {
                    this.$Message.error('请填写必填项！');
                }
            })

        },
        Ok() {
            this.getInvoice()
        }
    }
}
</script>
<style lang="less" scoped>
.myheader {
    font-size: 16px;
    font-weight: 400;
    height: 50px;
}
</style>